<template>
  <v-container
    id="app-info-badge"
    class="pa-1"
  >
    <screen
      :title="$t('words.solde')"
      :info="$amount(solde)"
    />

    <div class="bloc-action">
      <div v-show="!showTransferOptions">
        <action-btn
          :title="$t('button.bi_client')"
          color="grey"
          class="mb-3"
          icon="person"
          name="client"
          @click="toCustomer"
        />
        <action-btn
          v-if="useCashlessTransfer"
          :title="$t('button.bi_transfert')"
          :disabled="solde <= 0"
          color="grey"
          class="mb-3"
          icon="mdi-share"
          name="tranfer"
          @click="showTransferOptions = true"
        />
        <action-btn
          v-if="badge.Loyalty === 1"
          :title="$t('button.purchase')"
          color="grey"
          class="mb-3"
          icon="mdi-cart"
          name="buy"
          @click="showAmountEntry = true"
        />
        <!--<action-btn-->
        <!--  v-if="useDebit"-->
        <!--  :title="$t('button.bi_debit')"-->
        <!--  color="grey"-->
        <!--  class="mb-3"-->
        <!--  icon="mdi-gift"-->
        <!--  name="debit"-->
        <!--  @click="debit"-->
        <!--/>-->
        <action-btn
          :title="$t('button.bi_consultation')"
          color="grey"
          icon="mdi-information"
          name="consultation"
          @click="consult()"
        />
        <action-btn
          :title="$t('button.bi_duplication')"
          color="grey"
          icon="mdi-file-plus"
          class="mt-3"
          name="duplication"
          @click="duplicate()"
        />
        <action-btn
          :title="$tc('button.bi_voucher', (badge && badge.LSTVCH ? badge.LSTVCH.Nb : 0))"
          :disabled="!badge || !badge.LSTVCH"
          color="grey"
          icon="mdi-file-multiple"
          class="mt-3"
          name="voucehr"
          @click="toVouchers"
        />
        <!-- ***** ANNULATION ***** -->
        <v-divider class="my-2" />
        <action-btn
          :title="$t('button.bi_cancelation')"
          color="red"
          icon="mdi-history"
          name="cancellation"
          use-title-color
          @click="cancelDialog = true"
        />
        <ui-dialog
          v-model="cancelDialog"
          :title="$t('dialog.cancellation_title')"
          :content="$t('dialog.cancellation_content')"
          :btn-cancel="$t('button.back')"
          btn-validate="OK"
          danger
          @validate="cancelDialog = false; cancel()"
          @hide="cancelDialog = false"
        />
      </div>
      <div v-show="showTransferOptions">
        <action-btn
          :title="$t('button.bi_transfert_partial')"
          color="grey"
          icon="mdi-share"
          name="tranfer-partial"
          @click="showAmountEntry = true"
        />
        <action-btn
          :title="$t('button.bi_transfert_total')"
          color="grey"
          class="mt-3"
          icon="mdi-share"
          name="tranfer-total"
          @click="transfer()"
        />
      </div>
    </div>

    <keyboard-dialog
      v-model="showAmountEntry"
      :title="showTransferOptions ? $t('title.solde_transfer') : 'Enregistrement d\'un achat'"
      :screen-title="showTransferOptions ? 'Montant à transférer' : 'Montant de l\'achat'"
      :solde="solde"
      :use-solde-screen="showTransferOptions"
      :use-default-screen="!showTransferOptions"
      auto-close
      @valid="validAmount"
    />

    <bottom-action
      btn-cancel
      btn-valid-disabled
      @cancel="bottomCancel"
      @del="bottomDelete"
    />
  </v-container>
</template>

<script>
import { ActionEnum } from '@/modules/Enums'
import { Operations } from '@/modules/Operations'
import { Scan } from '@/modules/Scan'
import { $alert, $amount } from '@/modules/Utils'

import KeyboardDialog from '@/components/modal/KeyboardDialog'

export default {
  name: 'InfoBadgeView',

  components: {
    KeyboardDialog
  },

  props: {
    badge: { type: Object, default: null },
    carrier: { type: Object, default: null },
    customers: { type: Array, default: null },
    backToHome: { type: Boolean, default: false }
  },

  data () {
    return {
      solde: 0,
      cancelDialog: false,
      //
      showTransferOptions: false,
      showAmountEntry: false
    }
  },

  computed: {
    useCashlessTransfer () {
      return this.$store.getters.useCashlessTransfer && !this.$store.getters.isMobil
    }
    // useDebit () {
    //   return this.badge.Loyalty === 1 && this.solde > 0
    // }
  },

  beforeMount () {
    if (this.badge === null) {
      this.$router.replace('/home')
    }
  },

  mounted () {
    if (this.badge && this.badge.PME && this.badge.PME.Solde) {
      this.solde = this.badge.PME.Solde
    }
  },

  methods: {
    $amount,
    bottomDelete () {
      if (this.showTransferOptions) {
        this.showTransferOptions = false
      } else {
        if (this.backToHome) {
          this.bottomCancel()
        } else if (this.customers !== null) {
          this.$router.replace({
            name: 'customer-search',
            params: { customers: this.customers }
          })
        } else {
          this.$router.replace({
            name: 'scan-nfc',
            params: { action: ActionEnum.badgeInformations, mode: 'P', backToHome: true }
          })
        }
      }
    },
    bottomCancel () {
      this.$router.replace('/home')
    },
    consult () {
      Operations.badgeConsultation(
        this.badge.IDBadge,
        this.carrier,
        (message) => { $alert(message, 'success') },
        (error) => { $alert(error) }
      )
    },
    cancel () {
      Operations.badgeCancellation(
        this.badge.IDBadge,
        this.carrier,
        (message) => { $alert(message, 'success') },
        (error) => { $alert(error) }
      )
    },
    duplicate () {
      Operations.badgeDuplicate(
        this.badge.IDBadge,
        this.carrier,
        (message) => { $alert(message, 'success') },
        (error) => { $alert(error) }
      )
    },
    //
    validAmount (amount) {
      if (this.showTransferOptions) this.transfer(amount)
      else this.buy(amount)
    },
    transfer (amount = null) {
      this.$emit('title', this.$i18n.t('title.solde_transfer'))
      this.$store.commit('amount', amount ? amount : this.badge.PME.Solde)
      this.$router.replace({
        name: 'scan-nfc',
        params: { idBadge: this.badge.IDBadge, action: ActionEnum.cashlessTransfert, mode: 'P' }
      })
    },
    buy (amount) {
      this.$store.commit('amount', amount)

      if (this.badge.QuestionsCLI || this.badge.QuestionsFID) {
        this.$router.replace({
          name: 'loyalty-questions',
          params: { idBadge: this.badge.IDBadge, clientQuestions: this.badge.QuestionsCLI, loyaltyQuestions: this.badge.QuestionsFID }
        })
      } else {
        Scan.launchFidCalcul(
          this.badge.IDBadge,
          (error) => {
            $alert(error)
          }
        )
      }
    },
    toVouchers () {
      this.$router.replace({
        name: 'vouchers',
        params: { badge: this.badge, carrier: this.carrier }
      })
    },
    toCustomer () {
      this.$router.replace({
        name: 'customer',
        params: { customer: this.carrier, badge: this.badge, customers: this.customers }
      })
    }
  }
}
</script>
